import React from "react";
import PropTypes from "prop-types";
import { Provider } from "mobx-react";

import SubRequestStorage from "../../storages/SubRequestStorage";
import SubRequests from "./SubRequests";

const Container = ({
  currentUserHasScheduleManageAccess,
  locations,
  positions,
  currentUserPositions,
  page,
  noRecordsMessage
}) => {
  const subRequestStorage = new SubRequestStorage(
    currentUserHasScheduleManageAccess,
    locations,
    positions,
    currentUserPositions,
    page
  );
  const storage = { subRequestStorage };

  return (
    <Provider {...storage}>
      <SubRequests noRecordsMessage={noRecordsMessage} />
    </Provider>
  );
};

Container.propTypes = {
  currentUserHasScheduleManageAccess: PropTypes.bool,
  locations: PropTypes.array,
  positions: PropTypes.array,
  currentUserPositions: PropTypes.array,
  page: PropTypes.string,
  noRecordsMessage: PropTypes.string
};

export default Container;
